<mat-toolbar class="background-color-green" style=" position: sticky; top: 0; z-index: 7;">            
    
    <a [routerLink]="" (click)="backClicked()">
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="arrow_back" style="padding-top:9px; margin-right:10px; color:white;"></mat-icon>
    </a>        
    <span class="text-color-white">{{ 'ml_151240' | translate }}</span>                
    <span class="text-color-white" style="margin-left: 6px;" *ngIf="browserLangToUse.includes('zh')"> ( {{ apexId }} )</span>       
</mat-toolbar>

<div *ngIf="isLoading" class="center">
    <mat-spinner class="example-margin" [color]="color"></mat-spinner>
</div>

<div *ngIf="!isLoading">
    <mat-accordion class="example-headers-align">
        <mat-list>
            @if(learnexObjectArray.data.length === 0){
                <span class="text-color-blue" style="font-size: 20px; margin-left: 10px;">{{ 'ml_151232' | translate }}</span>
            }
            @else {
                
                <mat-expansion-panel [hideToggle]="learnexObjectArrayOverDue.length === 0" 
                    [disabled]="learnexObjectArrayOverDue.length === 0"
                    [expanded]="learnexObjectArrayOverDue.length > 0 ? true : false" >
                    <mat-expansion-panel-header style="color: rgba(0,0,0,0.86); " style="height: 40px;">
                        <mat-panel-title class="flex-basis-200px text-color-green font-size-21px" style="color: #009947;" >
                            {{ 'ml_151241' | translate }}
                        </mat-panel-title>
                        <mat-panel-description class="text-color-blue font-size-21px" style="color: #00BFFF;">
                            {{learnexObjectArrayOverDue.length === 0 ? 0 : learnexObjectArrayOverDue.length}}
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    @for (learnex of learnexObjectArrayOverDue; track learnex) {                
                        <mat-card class="example-card mat-card-background-color-white-smoke">
                            <mat-card-header style="padding-bottom: 16px;">
                                <mat-card-title class="font-size-16px">
                                    <span class="font-weight-600">{{ 'ml_151238' | translate }}: </span>
                                    <span>{{ learnex.dueDate.split('T')[0] }}</span>
                                </mat-card-title>
                                <mat-card-subtitle class="font-size-16px">
                                    <span class="font-weight-600">{{ 'ml_151239' | translate }}: </span>
                                    <span>{{ learnex.trainingTitle }}</span>
                                    
                                </mat-card-subtitle>
                            </mat-card-header>
                        </mat-card>
                    }
                </mat-expansion-panel>
                
                <mat-expansion-panel [hideToggle]="learnexObjectArrayDueSoon.length === 0" 
                    [disabled]="learnexObjectArrayDueSoon.length === 0"
                     >
                    <mat-expansion-panel-header style="color: rgba(0,0,0,0.86); " style="height: 40px;">
                        <mat-panel-title class="flex-basis-200px text-color-green font-size-21px" style="color: #009947;" >
                            {{ 'ml_151242' | translate }}
                        </mat-panel-title>
                        <mat-panel-description class="text-color-blue font-size-21px" style="color: #00BFFF;">
                            {{learnexObjectArrayDueSoon.length === 0 ? 0 : learnexObjectArrayDueSoon.length}}
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    @for (learnex of learnexObjectArrayDueSoon; track learnex) {                
                        <mat-card class="example-card mat-card-background-color-white-smoke">
                            <mat-card-header style="padding-bottom: 16px;">
                                <mat-card-title class="font-size-16px">
                                    <span class="font-weight-600">{{ 'ml_151238' | translate }}: </span>
                                    <span>{{ learnex.dueDate.split('T')[0] }}</span>
                                </mat-card-title>
                                <mat-card-subtitle class="font-size-16px">
                                    <span class="font-weight-600">{{ 'ml_151239' | translate }}: </span>
                                    <span>{{ learnex.trainingTitle }}</span>
                                    
                                </mat-card-subtitle>
                            </mat-card-header>
                        </mat-card>
                    }
                </mat-expansion-panel>
                
                
                <mat-expansion-panel [hideToggle]="learnexObjectArrayNoDueDate.length === 0" 
                    [disabled]="learnexObjectArrayNoDueDate.length === 0"
                     >
                    <mat-expansion-panel-header style="color: rgba(0,0,0,0.86); " style="height: 40px;">
                        <mat-panel-title class="flex-basis-200px text-color-green font-size-21px" style="color: #009947;" >
                            {{ 'ml_151243' | translate }}
                        </mat-panel-title>
                        <mat-panel-description class="text-color-blue font-size-21px" style="color: #00BFFF;">
                            {{learnexObjectArrayNoDueDate.length === 0 ? 0 : learnexObjectArrayNoDueDate.length}}
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                    @for (learnex of learnexObjectArrayNoDueDate; track learnex) {                
                        <mat-card class="example-card mat-card-background-color-white-smoke">
                            <mat-card-header style="padding-bottom: 16px;">
                                <mat-card-title class="font-size-16px">
                                    
                                </mat-card-title>
                                <mat-card-subtitle class="font-size-16px">
                                    <span class="font-weight-600">{{ 'ml_151239' | translate }}: </span>
                                    <span>{{ learnex.trainingTitle }}</span>
                                    
                                </mat-card-subtitle>
                            </mat-card-header>
                        </mat-card>
                    }
                </mat-expansion-panel>
                
            }
        </mat-list>
    </mat-accordion>
    
</div>